module.exports = __webpack_public_path__ + "img/icon_gnb_arrow_up.fd5ff3ce.svg";